@defer (when !conceptService.loading() && !conceptService.loadingErrorMessage()) {
  <div class="h100">
    <awc-grid [config]="config">
      <app-left-section [selectedSection]="selectedSection"></app-left-section>

      @if (!(page.section === ConceptSections.REQUIREMENT && page.subsection === ConceptSubSection.COMPARISON_TOOL)) {
        <data-display-panel [type]="page.section" [template]="architectureService.template"></data-display-panel>
      } @else {
        <app-data-display-comparison-tool [conceptSection]="page.section"></app-data-display-comparison-tool>
      }
    </awc-grid>
  </div>
} @placeholder () {
  <app-loading-content-screen></app-loading-content-screen>
}
